<template>
    <vs-chip class="ag-grid-cell-chip" :color="chipColor(params)">
        <span>{{ organizationStatusString(params) }}</span>
    </vs-chip>
</template>

<script>
export default {
    name: 'CellRendererStatus',
    computed: {
        chipColor() {
            return value => {
                if (value.data.sendStatus === 1) {
                    return "complete"
                } else if (value.data.sendStatus === 0) {
                    return "primary"
                }
            }
        },
        organizationStatusString() {
            return value => {
                if (value.data.sendStatus === 1) {
                    return this.$t('navMenu.smsStatusDone')
                } else if (value.data.sendStatus === 0) {
                    return this.$t('navMenu.smsStatus')
                }
            }
        }
    }
}
</script>

<style lang="scss">
.ag-grid-cell-chip {
    &.vs-chip-success {
        background: rgba(var(--vs-success), .15);
        color: rgba(var(--vs-success), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-danger {
        background: rgba(var(--vs-danger), .15);
        color: rgba(var(--vs-danger), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-warning {
        background: rgba(var(--vs-warning), .2);
        color: rgba(var(--vs-warning), 1) !important;
        font-weight: 500;
    }

    &.vs-chip-skyblue {
        background: rgb(135, 206, 235, .2) !important;
        color: rgb(135, 206, 235) !important;
        font-weight: 500;
    }

    &.vs-chip-complete {
        background: rgba(157, 101, 201, .2) !important;
        color: rgb(157, 101, 201) !important;
        font-weight: 500;
    }
}
</style>
